export default {
  apiEndPoint: 'https://staging2.replayer.it/api',
  sharedVideoBaseUrl: 'https://staging2.replayer.it/v',
  paypalClientId: 'AU6RD20aNW4xy7x5vpJiWxh3TUqrPie5vMAHgke5gGd7Y8wVQYZ4z2PnxBHNU57I7GNly5qQ46lx5bd5',
  paypalMerchantId: 'Z6HL3B45HLSGU',
  googleClientId: '983057732726-4prkgall2oo0caaml6hq9tqp7lhpira0.apps.googleusercontent.com',
  appleClientId: 'it.replayer.web.staging',
  appleRedirectUri: 'https://staging2.replayer.it/login',
  baseUrl: 'https://staging2.replayer.it',
  krpanoPlayerUrl: 'https://staging2.replayer.it/krpano/',
  videoAnalysisReplayerUiEnabled: true
};
